module.exports = __webpack_public_path__ + "static/fcra-fin-2018-19-80acc1f2532263f6c705e957826f4b86.pdf";